export default __webpack_public_path__ + "static/media/template25.3ba72c8e.svg";